import { defaultAppConfigValues } from "@configs/custom-app-config-defaults";
import {
	type CustomConfigType,
	customConfigTypeSchema,
} from "@configs/custom-app-config-schema";
import camelCase from "lodash-es/camelCase";
import mapKeys from "lodash-es/mapKeys";
import merge from "lodash-es/merge";

export const parseAppConfig = (
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	data: any,
): CustomConfigType | null => {
	if (!data) {
		return null;
	}

	// On mobile, .single() sometimes returns an array instead of object
	const formattedData = Array.isArray(data) ? data[0] : data;
	const { _id, ...rest } = formattedData;

	const camelCasedData = mapKeys(rest, (_value, key) => camelCase(key));
	const parsedData = customConfigTypeSchema.safeParse(camelCasedData);

	if (!parsedData.success) {
		console.error("❌ Error parsing custom app config:", parsedData.error);
		const mergedData = merge({}, defaultAppConfigValues, camelCasedData);
		return mergedData as unknown as CustomConfigType;
	}

	return parsedData.data;
};
